import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ChartGeospatialSchema } from '$lib/sanity/schemas/components/Chart';
import { ComponentType } from '$lib/sanity/types';

export const MapSchema = SanityDocumentSchema.merge(ChartGeospatialSchema).extend({
  _type: z.literal(ComponentType.Map)
});

export type Map = z.infer<typeof MapSchema>;
